var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/web.immediate.js
// module id = hCo4
// module chunks = 0